module.exports = __webpack_public_path__ + "img/bgi.078201e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bgi.jpg
// module id = NfYL
// module chunks = 1